
import { Stack, Typography } from "@mui/material";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { LearningActivity } from "types";
import { CloseModalButton, HeaderStyled, HeaderTitleGroup, SubHeaderText } from "./LearningActivity.styles";
import { StatusBoxesContainer } from "../../components/CarouselCardRestyle/CarouselCard.style";
import { useLevel } from "../../hooks";
import { formatDuration_h_m, hasPassedExpiration } from "../../utils/datetime";
import { isExemptLo } from "../../utils/exemption";

type IHeader = {
  handleClose: (e: React.MouseEvent<HTMLButtonElement>) => void,
  activity: LearningActivity,
  hideStatusBoxes?: boolean
}
export const Header = ({
  handleClose,
  activity,
  hideStatusBoxes = false
}: IHeader) => {
  const { t } = useTranslation();

  const {
    title,
    id,
    isMandatory,
    status,
    expirationDate,
    isExpirationDateHard,
    learningObjectTypology,
    isToj,
    isFavourite,
    attributes,
    credits,
    duration
  } = activity;

  const typologyLabel = useLevel(learningObjectTypology);
  const isClassroom = learningObjectTypology === "DA_PHYSICAL_CLASS" || learningObjectTypology === "DA_VIRTUAL_CLASS";
  const durationLabel = duration ? formatDuration_h_m(duration) : "";
  const subHeaderLabel = [typologyLabel, durationLabel].filter(Boolean).join(" | ");

  return (
    <HeaderStyled
      id="modal-header"
    >
      <Stack
        flexDirection={ "row" }
        justifyContent={ "space-between" }
        alignItems={ "start" }
        width={ "50%" }
      >
        <HeaderTitleGroup>
          <Typography
            id="modal-title"
            fontSize={ "1.25rem" }
            fontWeight={ 700 }
            lineHeight={ "1.5rem" }
          >
            { title }
          </Typography>
          { subHeaderLabel ? (
            <SubHeaderText>
              { subHeaderLabel }
            </SubHeaderText>
          ) : null }
        </HeaderTitleGroup>
        <CloseModalButton
          id="close-modal-icon"
          type="button"
          aria-label={ t("close") }
          onClick={ (e) => handleClose(e) }
        >
          <X size={ "1.5rem" } aria-hidden="true" />
        </CloseModalButton>
      </Stack>
      { !hideStatusBoxes && <Stack
        flexDirection={ "row" }
        flexWrap={ "wrap" }
        gap={ "0.5rem" }
        aria-hidden="true"
        tabIndex={ -1 }
      >
        <StatusBoxesContainer
          id={ id }
          isMandatory={ isMandatory }
          endDate={ undefined }
          isCompleted={ status === "C" }
          isExempt={ isExemptLo(status) }
          inProgress={ !isClassroom && status === "P" }
          isExpired={ hasPassedExpiration(expirationDate) }
          isExpirationDateHard={ isExpirationDateHard }
          expirationDate={ expirationDate }
          startDate={ undefined }
          learningObjectTypology={ learningObjectTypology }
          isToj={ isToj }
          isFavourite={ isFavourite }
          attributes={ attributes }
          // isSuggestedAI={ isSuggestedAI }
          // isSuggestedHR={ isSuggestedHR }
          // isSuggestedManager={ isSuggestedManager }
          credits={ credits }
        />
      </Stack> }
    </HeaderStyled>
  );
};
